import { render, staticRenderFns } from "./PremiumBanner.vue?vue&type=template&id=47f02d62"
import script from "./PremiumBanner.vue?vue&type=script&lang=js"
export * from "./PremiumBanner.vue?vue&type=script&lang=js"
import style0 from "./PremiumBanner.vue?vue&type=style&index=0&id=47f02d62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports